import { Layers, Search } from "lucide-react";

export function VectorArtsContent() {
  return (
    <div className="flex size-full flex-1 flex-col items-center justify-center gap-4 rounded-lg border-2 border-dashed border-green-400 p-8">
      <div className="flex items-center gap-2">
        <Layers className="size-6 text-green-600" />
        <h2 className="text-xl font-semibold leading-[30px] text-gray-900">
          Vector Arts Collection
        </h2>
      </div>

      <div className="flex flex-col items-center gap-4 text-center">
        <Search className="size-12 text-green-500" />
        <div className="space-y-2">
          <h3 className="text-lg font-medium text-gray-800">Browse Vector Graphics</h3>
          <p className="max-w-md text-sm text-gray-600">
            Explore our collection of scalable vector graphics perfect for apparel designs.
          </p>
        </div>

        <div className="mt-4 space-y-2">
          <button
            className="rounded-lg bg-green-600 px-6 py-3 text-white hover:bg-green-700"
            data-testid="browse-collection-button"
          >
            Browse Collection
          </button>
          <p className="text-xs text-gray-500">Access thousands of vector graphics</p>
        </div>
      </div>
    </div>
  );
}
